import { get } from "./get"
import { getByToken } from "./get-by-token"
import { getUserDates } from "./get-user-dates"
import { updateTargetObjetive } from "./update-target-objetive"
import { getUserReports } from "./get-user-reports"

export const courses = {
  get,
  getByToken,
  getUserDates,
  updateTargetObjetive,
  getUserReports,
}
